module.exports = __webpack_public_path__ + "img/love.02d3164c.gif";